<h1 matDialogTitle>{{dialogTitle}}</h1>

<mat-dialog-content>
  <form class="dynamic-form" [formGroup]="form" style="width: 100%">
    <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">


      <!--First Row -->
      <mat-card-subtitle style="margin: 0px!important;padding: 0px!important;font-weight: bold;" fxFlex="100">General
        Details
      </mat-card-subtitle>
      <mat-form-field fxFlex="25" width="100%">
        <mat-label>Customer Indicator *</mat-label>
        <mat-select formControlName="customerIndicator" (selectionChange)="customerIndicatorChanged($event.value, true)">
          <mat-option [value]="'Business'">Business</mat-option>
          <mat-option [value]="'Customer'">Customer</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field fxFlex="50" width="100%">
        <mat-label>{{form.value.customerIndicator === 'Customer' ? 'Customer Name' : 'Business Name *'}}</mat-label>
        <input #customerName matInput type="text" formControlName="customerName" maxlength="50" autocomplete="new-password">
        <mat-hint align="end">{{customerName.value.length}} / 50</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex="25" width="100%">
        <mat-label>Vat Reg. No</mat-label>
        <input #companyTaxNumber matInput type="text" formControlName="companyTaxNumber" maxlength="15" autocomplete="new-password">
        <mat-hint align="end">{{companyTaxNumber.value.length}} / 15</mat-hint>
      </mat-form-field>

      <div fxFlex="100" style="min-height: 16px">&nbsp;</div>
      <!--Second Row -->
      <mat-card-subtitle style="margin: 0px!important;padding: 0px!important;font-weight: bold;" fxFlex="100">Primary
        Contact Details
      </mat-card-subtitle>

      <mat-form-field fxFlex="10" width="100%">
        <mat-label>Title *</mat-label>
        <mat-select formControlName="title" (selectionChange)="setCustomerName()">
          <mat-option *ngFor="let title of titles" [value]="title.code">
            {{title.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field fxFlex="40" width="100%">
        <mat-label>First Name *</mat-label>
        <input #firstName matInput type="text" formControlName="firstName" maxlength="30" autocomplete="new-password" (change)="setCustomerName()">
        <mat-hint align="end">{{firstName.value.length}} / 30</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex="50" width="100%">
        <mat-label>Last Name *</mat-label>
        <input #surname matInput type="text" formControlName="surname" maxlength="30" autocomplete="new-password" (change)="setCustomerName()">
        <mat-hint align="end">{{surname.value.length}} / 30</mat-hint>
      </mat-form-field>


      <!--Third Row -->
      <mat-form-field fxFlex="50" width="100%">
        <mat-label>Email *</mat-label>
        <input #email matInput type="email" formControlName="email" maxlength="255" autocomplete="new-password">
        <mat-hint align="end">{{email.value.length}} / 255</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex="20" width="100%">
        <mat-label>Cellphone Nr. *</mat-label>
        <input #telephone matInput type="text" formControlName="telephone" maxlength="20" autocomplete="new-password">
        <mat-hint align="end">{{telephone.value.length}} / 20</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex="20" width="100%">
        <mat-label>SA ID</mat-label>
        <input #said matInput type="text" formControlName="saId" maxlength="13" autocomplete="new-password">
        <mat-hint align="end">{{said.value.length}} / 13</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex="10" width="100%">
        <mat-label>VIP</mat-label>
        <input #vip matInput type="text" formControlName="vip" maxlength="8" autocomplete="new-password">
        <mat-hint align="end">{{vip.value.length}} / 8</mat-hint>
      </mat-form-field>


      <div fxFlex="100" style="min-height: 16px">&nbsp;</div>
      <!--Third Row -->
      <mat-card-subtitle style="margin: 0px!important;padding: 0px!important;font-weight: bold;" fxFlex="50">Second
        Contact Details
      </mat-card-subtitle>
      <mat-card-subtitle style="margin: 0px!important;padding: 0px!important;font-weight: bold;" fxFlex="50">Third
        Contact Details
      </mat-card-subtitle>
      <mat-form-field fxFlex="35" width="100%">
        <mat-label>Name</mat-label>
        <input #contact matInput type="text" formControlName="contact" maxlength="50" autocomplete="new-password">
        <mat-hint align="end">{{contact.value.length}} / 50</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex="15" width="100%">
        <mat-label>Telephone</mat-label>
        <input #addTelephone matInput type="text" formControlName="addTelephone" maxlength="20"
          autocomplete="new-password">
        <mat-hint align="end">{{addTelephone.value.length}} / 20</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex="35" width="100%">
        <mat-label>Name</mat-label>
        <input #contactPlus matInput type="text" formControlName="contactPlus" maxlength="50"
          autocomplete="new-password" v>
        <mat-hint align="end">{{contactPlus.value.length}} / 50</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex="15" width="100%">
        <mat-label>Telephone</mat-label>
        <input #contractNr matInput type="text" formControlName="contractNr" maxlength="20" autocomplete="new-password">
        <mat-hint align="end">{{contractNr.value.length}} / 20</mat-hint>
      </mat-form-field>


      <div fxFlex="100" style="min-height: 16px">&nbsp;</div>
      <!--First Row -->
      <mat-card-subtitle style="margin: 0px!important;padding: 0px!important;font-weight: bold;" fxFlex="100">
        Communication Preferences
      </mat-card-subtitle>
      <mat-checkbox fxFlex="25" formControlName="noEmail" value="" color="primary">No Email</mat-checkbox>
      <mat-checkbox fxFlex="25" formControlName="noDirectEmail" value="" color="primary">No Direct Email</mat-checkbox>
      <mat-checkbox fxFlex="25" formControlName="noTelephone" value="" color="primary">No Telephone</mat-checkbox>
      <mat-checkbox fxFlex="25" formControlName="noSms" value="" color="primary">No SMS</mat-checkbox>



      <div fxFlex="100" style="min-height: 16px">&nbsp;</div>
      <!-- Addresses-->
      <div fxFlex="50"
        style="display: flex;flex-direction: row;flex-wrap: nowrap;align-content: stretch;justify-content: space-between;align-items: center;">
        <mat-card-subtitle style="margin: 0px!important;padding: 0px!important;font-weight: bold;">Billing Address
        </mat-card-subtitle>
        <div>
          <button mat-button (click)="copyAddress('ship','sold')">Copy from Shipping</button>
        </div>
      </div>
      <div fxFlex="50"
        style="display: flex;flex-direction: row;flex-wrap: nowrap;align-content: stretch;justify-content: space-between;align-items: center;">
        <mat-card-subtitle style="margin: 0px!important;padding: 0px!important;font-weight: bold;">Shipping Address
        </mat-card-subtitle>
        <div>
          <button mat-button (click)="copyAddress('sold','ship')">Copy from Billing</button>
        </div>
      </div>

      <div fxFlex="100"
        style="display: flex;flex-direction: row;flex-wrap: nowrap;align-content: stretch;justify-content: space-between;align-items: center;"
        fxLayoutGap="16px grid">
        <div fxFlex="50" style="display: flex; flex-direction: column; justify-content: space-between">

          <mat-form-field fxFlex="50" width="100%">
            <mat-label>Building</mat-label>
            <input #soldToAddr1 matInput type="text" formControlName="soldToAddr1" maxlength="40"
              autocomplete="new-password">
            <mat-hint align="end">{{soldToAddr1.value.length}} / 40</mat-hint>
          </mat-form-field>


          <mat-form-field fxFlex="50" width="100%">
            <mat-label>Str/Unit Nr</mat-label>
            <input #soldToAddr2 matInput type="text" formControlName="soldToAddr2" maxlength="40"
              autocomplete="new-password">
            <mat-hint align="end">{{soldToAddr2.value.length}} / 40</mat-hint>
          </mat-form-field>

          <mat-form-field fxFlex="50" width="100%">
            <mat-label>Street Name</mat-label>
            <input #soldToAddr3 matInput type="text" formControlName="soldToAddr3" maxlength="40"
              autocomplete="new-password">
            <mat-hint align="end">{{soldToAddr3.value.length}} / 40</mat-hint>
          </mat-form-field>

          <mat-form-field fxFlex="50" width="100%">
            <mat-label>Suburb / City</mat-label>
            <input #soldToAddr4 matInput type="text" formControlName="soldToAddr4" maxlength="40"
              autocomplete="new-password">
            <mat-hint align="end">{{soldToAddr4.value.length}} / 40</mat-hint>
          </mat-form-field>

          <mat-form-field fxFlex="50" width="100%">
            <mat-label>Province</mat-label>
            <input #soldToAddr5 matInput type="text" formControlName="soldToAddr5" maxlength="40"
              autocomplete="new-password">
            <mat-hint align="end">{{soldToAddr5.value.length}} / 40</mat-hint>
          </mat-form-field>

          <mat-form-field fxFlex="50" width="100%">
            <mat-label>Postal Code</mat-label>
            <input #soldPostalCode matInput type="text" formControlName="soldPostalCode" maxlength="10"
              autocomplete="new-password">
            <mat-hint align="end">{{soldPostalCode.value.length}} / 10</mat-hint>
          </mat-form-field>

          <mat-form-field fxFlex="25" width="100%">
            <mat-label>Latitude</mat-label>
            <input #soldToGpsLat matInput type="number" formControlName="soldToGpsLat" autocomplete="new-password">
          </mat-form-field>
          <mat-form-field fxFlex="25" width="100%">
            <mat-label>Longitude</mat-label>
            <input #soldToGpsLong matInput type="number" formControlName="soldToGpsLong" autocomplete="new-password">
          </mat-form-field>

        </div>

        <div fxFlex="50" style="display: flex; flex-direction: column">

          <mat-form-field fxFlex="100" width="100%">
            <mat-label>Building</mat-label>
            <input #shipToAddr1 matInput type="text" formControlName="shipToAddr1" maxlength="40"
              autocomplete="new-password">
            <mat-hint align="end">{{shipToAddr1.value.length}} / 40</mat-hint>
          </mat-form-field>

          <mat-form-field fxFlex="100" width="100%">
            <mat-label>Str/Unit Nr</mat-label>
            <input #shipToAddr2 matInput type="text" formControlName="shipToAddr2" maxlength="40"
              autocomplete="new-password">
            <mat-hint align="end">{{shipToAddr2.value.length}} / 40</mat-hint>
          </mat-form-field>

          <mat-form-field fxFlex="50" width="100%">
            <mat-label>Street Name</mat-label>
            <input #shipToAddr3 matInput type="text" formControlName="shipToAddr3" maxlength="40"
              autocomplete="new-password">
            <mat-hint align="end">{{shipToAddr3.value.length}} / 40</mat-hint>
          </mat-form-field>

          <mat-form-field fxFlex="50" width="100%">
            <mat-label>Suburb / City</mat-label>
            <input #shipToAddr4 matInput type="text" formControlName="shipToAddr4" maxlength="40"
              autocomplete="new-password">
            <mat-hint align="end">{{shipToAddr4.value.length}} / 40</mat-hint>
          </mat-form-field>

          <mat-form-field fxFlex="50" width="100%">
            <mat-label>Province</mat-label>
            <input #shipToAddr5 matInput type="text" formControlName="shipToAddr5" maxlength="40"
              autocomplete="new-password">
            <mat-hint align="end">{{shipToAddr5.value.length}} / 40</mat-hint>
          </mat-form-field>

          <mat-form-field fxFlex="50" width="100%">
            <mat-label>Postal Code</mat-label>
            <input #shipPostalCode matInput type="text" formControlName="shipPostalCode" maxlength="10"
              autocomplete="new-password">
            <mat-hint align="end">{{shipPostalCode.value.length}} / 10</mat-hint>
          </mat-form-field>

          <mat-form-field fxFlex="25" width="100%">
            <mat-label>Latitude</mat-label>
            <input #shipPostalCode matInput type="number" formControlName="shipToGpsLat" autocomplete="new-password">
          </mat-form-field>
          <mat-form-field fxFlex="25" width="100%">
            <mat-label>Longitude</mat-label>
            <input #shipPostalCode matInput type="number" formControlName="shipToGpsLong" autocomplete="new-password">
          </mat-form-field>

        </div>
      </div>

    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button mat-button [disabled]="!form.valid" (click)="save()">Save</button>
</mat-dialog-actions>
